import api from './api';
import { User } from './authService';

export interface UserUpdateRequest {
    firstName?: string;
    lastName?: string;
    email?: string;
    birthdate?: string;
    password?: string;
}

export const userService = {
    getCurrentUser: async (): Promise<User> => {
        const response = await api.get<User>('/users/me');
        return response.data;
    },

    updateProfile: async (data: UserUpdateRequest): Promise<void> => {
        await api.put('/users/profile', data);
    },
};
